import { Component, OnInit, Inject } from "@angular/core";
import { NotificationToastService } from "src/app/services/notification-toast.service";
import { ReservationService } from "src/app/services/reservation.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ReservationSearchItem } from "src/app/model/reservation-search-item";
import { PatientMail } from "src/app/model/patient/patient-mail";
import { PatientService } from "src/app/services/patient.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-patient-reservations-dialog",
  templateUrl: "./patient-mail-edit-dialog.component.html",
})
export class PatientMailEditDialogComponent implements OnInit {
  form: FormGroup;
  isEditing = false;
  loading = false;

  constructor(
    private patientService: PatientService,
    private formBuilder: FormBuilder,
    private notificationToastService: NotificationToastService,
    public dialogRef: MatDialogRef<PatientMailEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PatientMail
  ) {
    this.form = this.formBuilder.group({
      mail: [
        { value: data.Mail, disabled: data.PatientId ? true : false },
        [Validators.required, Validators.email],
      ],
      patientId: [{ value: data.PatientId }],
    });
  }

  editMail() {
    this.isEditing = true;
    this.form.controls.mail.enable();
  }

  get f() {
    return this.form.controls;
  }

  ngOnInit() {}

  async send() {

    if (this.form.valid) {
      try {
        this.loading = true;
        if (this.isEditing && this.data.PatientId) {
          await this.patientService.updatePatientMail(
            this.data.PatientId,
            this.form.controls.mail.value
          );
        }

        this.dialogRef.close(this.form.controls.mail.value);
      } catch ( err ) {
        this.notificationToastService.error(JSON.stringify( err.error ), 'Paciente Mail');
      } finally {
        this.loading = false;
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
